import React, {useState, useEffect} from 'react';
import { Box, Select, MenuItem, FormControl, Checkbox, Button, TextField, List, ListItem, ListItemIcon, Typography,
    IconButton,Fade,Modal } from '@mui/material';
import { ReactComponent as DropDownIcon } from "../../assets/icons/icon-angle-down.svg";
import { ReactComponent as DeleteLgIcon } from "../../assets/icons/icon-delete-btn-lg.svg";

import { ReactComponent as LeftAlignmentIcon } from "../../assets/icons/icon-alignment-left.svg";
import { ReactComponent as RightAlignmentIcon } from "../../assets/icons/icon-alignment-right.svg";
import { ReactComponent as CenterAlignmentIcon } from "../../assets/icons/icon-alignment-center.svg";
import { ReactComponent as TickIcon } from "../../assets/icons/icon-tick.svg";
import { ReactComponent as DeleteIcon } from "../../assets/icons/icon_trash.svg";
import { ReactComponent as DropdownAccordionIcon } from "../../assets/icons/icon-accordion-angle.svg";
//import { renderToString, renderToStaticMarkup } from 'react-dom/server'


export default function ReportMetrics({closeModal,setFormat,format,handleConditionalFormat,reportDetails,index,removeFormat,conditionalFormatArr }) {

    //const additionalMetricsRef = React.useRef(null);
    const [conditionalFormat,setConditionalFormat] = useState(format);
    const [formatColumn,setFormatColumn] = useState([]);
    const [removeFormatModalStatus,setRemoveFormatModalStatus]= useState(false)
    const COLUMN2_OPTIONS = [
        { sortKey: "Number", sortOrder: "0", value: "number", label: "Number" },
        { sortKey: "Heatmap", sortOrder: "1", value: "heatMap", label: "Heatmap" },
        { sortKey: "Bar", sortOrder: "2", value: "bar", label: "Bar" },
      ];
    const COLUMN3_OPTIONS = [
        { sortKey: "0", sortOrder: "0", value: "#F45E29", label: "#F45E29" },
        { sortKey: "1", sortOrder: "1", value: "#FA9E2D", label: "#FA9E2D" },
        { sortKey: "2", sortOrder: "2", value: "#4482FB", label: "#4482FB" },
        { sortKey: "3", sortOrder: "3", value: "#80CC8C", label: "#80CC8C" },
        { sortKey: "4", sortOrder: "4", value: "#E46179", label: "#E46179" },
        { sortKey: "5", sortOrder: "5", value: "#F3B85C", label: "#F3B85C" },
        { sortKey: "6", sortOrder: "6", value: "#B1EFBA", label: "#B1EFBA" },
        { sortKey: "7", sortOrder: "7", value: "#97A9B7", label: "#97A9B7" },
        { sortKey: "8", sortOrder: "8", value: "#85ADFC", label: "#85ADFC" },
        { sortKey: "9", sortOrder: "9", value: "#F45E30", label: "#F45E30" },
        { sortKey: "10", sortOrder: "10", value: "#FA9E2F", label: "#FA9E2F" },
        { sortKey: "11", sortOrder: "11", value: "#4482FC", label: "#4482FC" },
        { sortKey: "12", sortOrder: "12", value: "#80CC8D", label: "#80CC8D" },
        { sortKey: "13", sortOrder: "13", value: "#E46180", label: "#E46180" },
        { sortKey: "14", sortOrder: "14", value: "#F3B85D", label: "#F3B85D" },
        { sortKey: "15", sortOrder: "15", value: "#B1EFBB", label: "#B1EFBB" },
      ];
    const formControlRef = React.useRef(null);
    const COLUMN_PRECISION_OPTIONS = [
        { sortKey: "0", sortOrder: "0", value: "0", label: "0" },
        { sortKey: "1", sortOrder: "1", value: "1", label: "1" },
        { sortKey: "2", sortOrder: "2", value: "2", label: "2" },
        { sortKey: "3", sortOrder: "3", value: "3", label: "3" },
        { sortKey: "4", sortOrder: "4", value: "4", label: "4" },
        { sortKey: "5", sortOrder: "5", value: "5", label: "5" },
      ];
    const [deleteIndex,setDeleteIndex] = useState(null)

    const handleFormatSelect = (key) => {
        return (e) => {
            e.stopPropagation()
            setConditionalFormat(prev => ({...prev, [key]: e?.target?.value})) 
        }
    }

    const handleRemoveFormat = (e,index) => {
        e.stopPropagation()
        setDeleteIndex(index)
        setRemoveFormatModalStatus(true)
    }
    const handleAllowRemoveFormat = (type) => {
        if(type) {
            return removeFormat(null,deleteIndex)
        }
        return setRemoveFormatModalStatus(false)
    }

    useEffect(() => {
      if(reportDetails?.reportDetails?.measures?.length) {
          let filtered = reportDetails?.reportDetails?.measures?.filter(measure => {
             let exist =  conditionalFormatArr?.find(f => f?.columnName === measure?.fieldName)
             if(!exist) return measure
          })

          setFormatColumn(filtered)
      }
    },[reportDetails, conditionalFormatArr])


    const handleAccordionState = (id) => {

        let elementId = '#column-' + id;
        const element = document.querySelector(elementId);
        const elements = Array.from(document.querySelectorAll(".accordion-column"));
        if(element.classList.contains('open')) {
            element.classList.remove('open');
        } else {
            elements.map((item => {
                item.classList.remove('open');
            }));
            element.classList.add('open');
        }
        
    }

    return (
        <Box className='re-modal-metrics'>
        <Box className='re-new-report-settings-modal-item accordion-column' id={`column-` + index}>
                <Box className="re-new-report-settings-modal-item-header" data-index={index} onClick={() => handleAccordionState(index)}>
                    <Box className="re-new-report-settings-modal-item-header-content"  >
                      <Button className='re-new-report-metrics-delete-icon'  title='Delete Metrics' onClick={(e) => handleRemoveFormat(e,index)} >
                            <DeleteIcon  />
                        </Button>
                        <Button className='re-new-report-metrics-dropdown-icon'  title=''>
                            <DropdownAccordionIcon />
                        </Button>
                        
                        <Typography variant='h6' className="font-weight-500 form_input_label re-modal-accordian-label"> {`${(format?.displayName || format?.columnName?.split('.')[1]) ||`Column#${index+1}`}` }</Typography>
                    </Box>
                </Box>
                <Box className='re-new-report-settings-modal-item-content'>
                    <Box>
                        <Box className='re-form-group' ref={formControlRef} >
                            <FormControl className='width-100' >
                                <Select
                                    key="columnKey"
                                    value={conditionalFormat?.columnName}
                                    onChange={handleFormatSelect('columnName')}
                                    renderValue={selected => !selected ? 'Select Column' : selected?.split('.')[1]}
                                    autoWidth={false}
                                    className={"re-select"}
                                    inputProps={{ 'aria-label': 'Without label' }}
                                    IconComponent={DropDownIcon}
                                    displayEmpty
                                    MenuProps={{
                                        anchorOrigin: {
                                            vertical: "bottom",
                                            horizontal: "left"
                                        },
                                        transformOrigin: {
                                            vertical: "top",
                                            horizontal: "left"
                                        },
                                        getContentAnchorEl: null,
                                        classes:{
                                            root: `re-select-items`,
                                        },
                                    }}
                                >
                                    {formatColumn?.map((option) => (
                                    <MenuItem className='re-select-item' value={option?.fieldName} key={option.fieldId}>{option?.displayName || option?.fieldName?.split('.')[1]}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
            {
                reportDetails?.reportDetails?.chartType === 'table' &&
                        <Box className='re-form-group'  >
                            <FormControl className='width-100' >
                                <Select
                                    key="visualType"
                                    value={conditionalFormat?.visualType}
                                    onChange={(e) => setConditionalFormat(prev => ({...prev,visualType: e.target.value}))}
                                    renderValue={selected => !selected ? 'Visual Type' : selected}
                                    autoWidth={false}
                                    className={"re-select"}
                                    inputProps={{ 'aria-label': 'Without label' }}
                                    IconComponent={DropDownIcon}
                                    displayEmpty
                                    MenuProps={{
                                        anchorOrigin: {
                                            vertical: "bottom",
                                            horizontal: "left"
                                        },
                                        transformOrigin: {
                                            vertical: "top",
                                            horizontal: "left"
                                        },
                                        getContentAnchorEl: null,
                                        classes:{
                                            root: `re-select-items`,
                                        },
                                    }}
                                >
                                    {COLUMN2_OPTIONS.map((option) => (
                                    <MenuItem className='re-select-item' value={option.value} key={option.value}>{option.label}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
            }
            {
                reportDetails?.reportDetails?.chartType === 'table' &&
                        <Box className='re-form-group'  >
                            <FormControl className='width-100'  >
                                <Select
                                    key="colorKey"
                                    renderValue={(selected) => !selected ? 'Select Color' : selected}
                                    value={conditionalFormat?.color}
                                    onChange={(e) => setConditionalFormat(prev => ({...prev, color: e?.target?.value}))}
                                    autoWidth={false}
                                    className={"re-select"}
                                    inputProps={{ 
                                        'aria-label': 'Without label'
                                    }}
                                    IconComponent={DropDownIcon}
                                    displayEmpty
                                    MenuProps={{
                                        anchorOrigin: {
                                            vertical: "bottom",
                                            horizontal: "left"
                                        },
                                        transformOrigin: {
                                            vertical: "top",
                                            horizontal: "left"
                                        },
                                        getContentAnchorEl: null,
                                        classes:{
                                            root: `re-select-items re-items-inline`,
                                        },
                                        PaperProps:{
                                            style: { padding: '0px', width: formControlRef?.current?.clientWidth + 'px' },
                                        }
                                    }}
                                >
                                    {/* <MenuItem className='re-select-item' value=""> Colors</MenuItem> */}
                                    {COLUMN3_OPTIONS.map((option) => (
                                    <MenuItem style={{backgroundColor: option.label }} className='re-select-item color-select-item' value={option.value} key={option.value}><TickIcon className="icon-tick" /></MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
            }

                    {
                        ( (conditionalFormat?.visualType === 'bar') && reportDetails?.reportDetails?.chartType === 'table'  )  &&
                        <Box className='re-form-group'  >
                            <FormControl className='width-100' >

                                <Box className='re-custom-textfield' onClick={(e) => setConditionalFormat(prev => ({...prev,showNumber: !conditionalFormat?.showNumber}))}>
                                    <Box className='re-custom-textfield-leftitem'>
                                        <Checkbox key="showNumber" id="numbers-input" className='re-checkbox' checked={(conditionalFormat?.showNumber ? true : false)} />
                                    </Box>
                                    <Box className='re-custom-textfield-content'>
                                        <Typography className="re-focus-none" for="numbers-input" variant='label' >Show numbers</Typography>
                                    </Box>
                                    <Box className={`re-custom-textfield-rightitem ` + (conditionalFormat?.showNumber ? `show` : ``)}>
                                        <DropDownIcon className="icon-dropdown" />
                                    </Box>
                                </Box>
                                <div className={`re-custom-textfield-dropdown ` + (conditionalFormat?.showNumber ? `show` : ``)}  >
                                    
                                    <List >
                                        <ListItem  onClick={(e) => setConditionalFormat(prev => ({...prev, alignment: 'left'}))} className={`re-custom-textfield-alignment-icons ` + ((conditionalFormat?.alignment === 'left') ? `selected`: ``)}>
                                            <ListItemIcon> <LeftAlignmentIcon /></ListItemIcon>
                                        </ListItem>
                                        <ListItem  onClick={(e) => setConditionalFormat(prev => ({...prev, alignment: 'center'}))}  className={`re-custom-textfield-alignment-icons ` + ((conditionalFormat?.alignment === 'center') ? `selected`: ``)}>
                                            <ListItemIcon> <CenterAlignmentIcon /></ListItemIcon>
                                        </ListItem>
                                        <ListItem  onClick={(e) => setConditionalFormat(prev => ({...prev, alignment: 'right'}))}  className={`re-custom-textfield-alignment-icons ` + ((conditionalFormat?.alignment === 'right') ? `selected`: ``)}>
                                            <ListItemIcon> <RightAlignmentIcon /></ListItemIcon>
                                        </ListItem>
                                    </List>
                                </div>

                            </FormControl>
                        </Box>
                    }
                    {
                        reportDetails?.reportDetails?.chartType === 'table' &&
                        <Box className='re-form-group'  >
                            <FormControl className='width-100' >

                                <Box className='re-custom-textfield' onClick={(e) => setConditionalFormat(prev => ({...prev, showCompactNumber: !conditionalFormat?.showCompactNumber}))}>
                                    <Box className='re-custom-textfield-leftitem'>
                                        <Checkbox key="compactNumber" id="compact-numbers" className='re-checkbox' checked={(conditionalFormat?.showCompactNumber ? true : false)}  />
                                    </Box>
                                    <Box className='re-custom-textfield-content'>
                                        <Typography className="re-focus-none"  for="compact-numbers" variant='label' >Compact numbers</Typography>
                                    </Box>
                                    
                                </Box>
                                

                            </FormControl>
                        </Box>
                    }

                        <Box className='re-form-group' ref={formControlRef} >
                            <FormControl className='width-100' >
                                <Select
                                    key="decimalPrecision"
                                    value={conditionalFormat?.decimalPrecision}
                                    renderValue={(selected) => !selected ? 'Decimal Precision' : selected}
                                    onChange={(e) => setConditionalFormat(prev => ({...prev, decimalPrecision: e?.target?.value}))}
                                    autoWidth={false}
                                    className={"re-select"}
                                    inputProps={{ 'aria-label': 'Without label' }}
                                    IconComponent={DropDownIcon}
                                    displayEmpty
                                    MenuProps={{
                                        anchorOrigin: {
                                            vertical: "bottom",
                                            horizontal: "left"
                                        },
                                        transformOrigin: {
                                            vertical: "top",
                                            horizontal: "left"
                                        },
                                        getContentAnchorEl: null,
                                        classes:{
                                            root: `re-select-items`,
                                        },
                                    }}
                                >
                                    <MenuItem className='re-select-item' value={'auto'
                                    } key={'auto'}>{'Auto'}</MenuItem>
                                    {COLUMN_PRECISION_OPTIONS.map((option) => (    
                                    <MenuItem className='re-select-item' value={option.value} key={option.value}>{option.label}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
            {
                ( (conditionalFormat?.visualType === 'bar' ) && reportDetails?.reportDetails?.chartType === 'table' )  &&
                        <Box className='re-form-group'  >
                            <FormControl className='width-100' >

                                        <Box className='re-custom-textfield' onClick={(e) => setConditionalFormat(prev => ({...prev, showTarget: !conditionalFormat?.showTarget}))}>
                                            <Box className='re-custom-textfield-leftitem'>
                                                <Checkbox className='re-checkbox' checked={(conditionalFormat?.showTarget ? true : false)} />
                                            </Box>
                                            <Box className='re-custom-textfield-content'>
                                                <Typography className="re-focus-none" variant='label' >Show target</Typography>
                                            </Box>
                                            <Box className={`re-custom-textfield-rightitem ` + (conditionalFormat?.showTarget ? `show` : ``)}>
                                                <DropDownIcon className="icon-dropdown" />
                                            </Box>
                                        </Box>
                                        <div className={`re-custom-textfield-dropdown no-outline ` + (conditionalFormat?.showTarget ? `show` : ``)}  >
                                            <TextField className='re-input' key="showTarget"
                                                value={conditionalFormat?.targetValue} 
                                                type="number"
                                                onChange={(e) => setConditionalFormat(prev => ({...prev, targetValue: e?.target?.value}))} 
                                                />
                                        </div>

                                    </FormControl>
                                </Box>
                        }

                        <Box className='text-right'>
                            {/* <Button onClick={e => handleConditionalFormat({type: 'cancel',currentFormat: conditionalFormat,index, setCurrentFormat: setConditionalFormat,closeModal})} color="primary" className="re-btn re-btn-outline re-btn-separator cancel" variant="outlined"  > Cancel </Button> */}
                            <Button onClick={e => handleConditionalFormat({type: 'save',currentFormat: conditionalFormat,index, setCurrentFormat: setConditionalFormat,handleAccordionState})} color="error" autoFocus className="re-btn re-btn-main submit" variant="contained"> Save </Button>
                        </Box>
                    </Box>
                </Box>
            </Box>  

        { removeFormatModalStatus &&   
          <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              className="modal-root re-modal"
              open={removeFormatModalStatus}
              closeAfterTransition
              >
              <Fade in={removeFormatModalStatus}>
                <Box className="modal-paper modal-box modal-xs" id="transition-modal-title">

                    <Box className="modal-content">
                      <Typography className="re-modal-xs-title">Delete Format</Typography>
                      <IconButton className="re-modal-xs-action-icon" ><DeleteLgIcon /></IconButton>
                      <Typography className="re-modal-xs-action-txt">Are you sure you want to delete this format?</Typography>
                      <Box className="re-modal-xs-action-items">
                        <Button  className="re-modal-xs-action-cancel-btn" onClick={e => handleAllowRemoveFormat(false)} variant="contained" >No</Button>
                        <Button className="re-modal-xs-action-submit-btn" onClick={e => handleAllowRemoveFormat(true)} variant="contained">Yes</Button>
                      </Box>
                    </Box>

                </Box>
              </Fade>
            </Modal>
}

        </Box>
    );
}